module.exports = new __parcel__URL__("menu-delete.8b6e2b8b.svg").toString();